module.exports = __webpack_public_path__ + "static/trvldrss-db0e3c95132c14320703d50cb586ad36.png";